// UI strings for the loading screen's lines to say aloud while a new version is taken into use
// (shell/update-lines.tsx). Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const updateLinesFi = {
  /** Above the line: what to do with it while waiting. */
  label: 'Sano ääneen',
};

export const updateLinesEn: typeof updateLinesFi = {
  label: 'Say it aloud',
};

// Messages.updateLines (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('updateLines', updateLinesFi, updateLinesEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof updateLinesFi> {}
}
